export default {
    course: {
        id: 1,
        className: "App\\Models\\Course"
    },
    event: {
        id: 2,
        className: "App\\Models\\Event"
    }
}


// WEBPACK FOOTER //
// ./services/constants/marketingListItemTypes.js